import styled from 'styled-components';

import { InputSearch } from 'ui/inputs';
import { PageHeader } from 'ui/pageHeader';
import { fonts, spacing } from 'ui/theme';

export const IndexPageContainer = styled.div`
  font-family: ${fonts.sansSerif};
`;

export const IndexHeaderActionContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const WideInputSearch = styled(InputSearch)`
  width: ${spacing.x16};
`;

export const StyledPageHeader = styled(PageHeader)`
  margin-bottom: ${spacing.double};
  align-items: center;
`;
